"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DxtUtils = void 0;
var DxtUtils = (function () {
    function DxtUtils() {
    }
    DxtUtils.correctIconName = function (icon) {
        return icon.indexOf('dx') == 0 ? " " + icon : icon;
    };
    DxtUtils.correctItemsIcons = function (items) {
        if (!items)
            return;
        items.forEach(function (i) {
            i.icon = i.icon ? DxtUtils.correctIconName(i.icon) : undefined;
            DxtUtils.correctItemsIcons(i.items);
        });
    };
    return DxtUtils;
}());
exports.DxtUtils = DxtUtils;
